import isPlainObj from"is-plain-obj";


const getOptions=(options={})=>{
if(!isPlainObj(options)){
throw new TypeError(`It must be a plain object: ${options}`)
}


const{message,...optionsA}=options;
return optionsA
};


const properties=({options})=>options;


export default{
name:"props",
getOptions,
properties
};